<template lang="pug">

div
  section.u-mt-md
    AppTitle(:title="$t('mantra')")
    .grid.is-desktop-8
      .column
        p.u-text-lg {{ $t('formDesc') }}

  section.u-mt-lg
    ValidationObserver(ref="form")
      form(slot-scope="{ validate }" @submit.prevent="validate().then(onSubmit)" novalidate)
        .grid.is-tablet-8.is-widescreen-6
          .column
            h3 {{ $t('personalInformation') }}
            TextInput(
              v-model="form.firstName"
              type="text"
              :label="$t('forms.fname')"
              rules="required"
              :disabled="isSubmitting"
            )
            TextInput(
              v-model="form.lastName"
              type="text"
              :label="$t('forms.lname')"
              rules="required"
              :disabled="isSubmitting"
            )
            TextInput(
              v-model="form.email"
              type="email"
              :label="$t('forms.businessEmail')"
              rules="required|email"
              :disabled="isSubmitting"
            )
            SelectInput(
              v-model="form.nationality"
              name="nationality"
              :label="$t('forms.citizenOf')"
              rules="required"
              :disabled="isSubmitting"
              :options="countries"
              track-by="iso2"
              label-by="name"
            )
            TextInput(
              v-model="form.phone"
              type="text"
              :label="$t('forms.mobile')"
              rules="required|numeric"
              :disabled="isSubmitting"
            )
            SelectInput(
              v-model="form.country"
              type="text"
              name="country"
              :label="$t('forms.permanentResident')"
              rules="required"
              :disabled="isSubmitting"
              :options="countries"
              track-by="iso2"
              label-by="name"
            )
            TextInput(
              v-model="form.birthDate"
              type="text"
              :label="$t('forms.dateBirth')"
              rules="required"
              :disabled="isSubmitting"
            )
            TextInput(
              v-model="form.address"
              type="textarea"
              :label="$t('forms.residenceAddress')"
              rules="required"
              :disabled="isSubmitting"
            )
            TextInput(
              v-model="form.taxId"
              type="text"
              :label="$t('forms.taxId')"
              rules="required"
              :disabled="isSubmitting"
            )
            TextInput(
              v-model="form.fax"
              type="text"
              :name="$t('forms.fax')"
              :label="`${$t('forms.fax')} ${$t('forms.optional')}`"
              rules="required|numeric"
              :disabled="isSubmitting"
            )
            TextInput(
              v-model="form.city"
              type="text"
              :label="$t('forms.city')"
              rules="required"
              :disabled="isSubmitting"
            )
            TextInput(
              v-model="form.state"
              type="text"
              :label="$t('forms.stateProvince')"
              rules="required"
              :disabled="isSubmitting"
            )

            h3 {{ $t('businessInformation') }}

            .form
              label.form-label {{ $t('forms.currentOccupation') }}
              label.radio.is-inline
                input.radio-input(type="radio" name="currentOccupation" :value="true" v-model="selfEmployed" :disabled="isSubmitting")
                | {{ $t('forms.selfEmployed') }}
              label.radio.is-inline
                input.radio-input(type="radio" name="currentOccupation" :value="false" v-model="selfEmployed" :disabled="isSubmitting")
                | {{ $t('forms.employedBy') }}
            TextInput(
              v-if="!selfEmployed"
              v-model="form.employer"
              :label="$t('forms.employer')"
              type="text"
              rules="required"
              :disabled="isSubmitting"
            )

            .form
              label.form-label {{$t('forms.similarExperience')}}
              label.radio.is-inline
                input.radio-input(type="radio" name="similarExperience" :value="true" v-model="hasExperience" :disabled="isSubmitting")
                | {{$t('forms.yes')}}
              label.radio.is-inline
                input.radio-input(type="radio" name="similarExperience" :value="false" v-model="hasExperience" :disabled="isSubmitting")
                | {{ $t('forms.noo') }}
            TextInput(
              v-if="hasExperience"
              v-model="form.experience"
              :label="$t('forms.tellMore')"
              type="textarea"
              rules="required"
              :disabled="isSubmitting"
            )

            .form
              label.form-label {{$t('forms.soleIncome')}}
              label.radio.is-inline
                input.radio-input(type="radio" name="soleIncome" :value="true" v-model="form.isOnlyIncome" :disabled="isSubmitting")
                | {{$t('forms.yes')}}
              label.radio.is-inline
                input.radio-input(type="radio" name="soleIncome" :value="false" v-model="form.isOnlyIncome" :disabled="isSubmitting")
                | {{$t('forms.noo')}}

            h3 {{$t('franchiseOperations')}}

            .form
              label.form-label {{$t('forms.whenInvest')}}
              label.radio
                input.radio-input(type="radio" name="investmentTime" value="NOW" v-model="form.investmentTime" :disabled="isSubmitting")
                | {{$t('forms.investOption1')}}
              label.radio
                input.radio-input(type="radio" name="investmentTime" value="IN_6_MONTHS" v-model="form.investmentTime" :disabled="isSubmitting")
                | {{$t('forms.investOption2')}}
              label.radio
                input.radio-input(type="radio" name="investmentTime" value="AFTER_6_MONTHS" v-model="form.investmentTime" :disabled="isSubmitting")
                | {{$t('forms.investOption3')}}
              label.radio
                input.radio-input(type="radio" name="investmentTime" value="OVER_1_YEAR" v-model="form.investmentTime" :disabled="isSubmitting")
                | {{$t('forms.investOption4')}}
            TextInput(
              v-model="form.involvement"
              type="text"
              :label="$t('forms.franchiseInvolved')"
              rules="required"
              :disabled="isSubmitting"
            )

            SelectInput(
              v-model="form.location"
              type="text"
              name="location"
              :label="$t('forms.whatCountry')"
              rules="required"
              :options="countries"
              :disabled="isSubmitting"
              track-by="iso2"
              label-by="name"
            )

            .form
              label.form-label {{$t('forms.haveInvestors')}}
              label.radio.is-inline
                input.radio-input(type="radio" name="haveInvestors" :value="true" v-model="form.haveInvestors" :disabled="isSubmitting")
                | {{ $t('forms.yes') }}
              label.radio.is-inline
                input.radio-input(type="radio" name="haveInvestors" :value="false" v-model="form.haveInvestors" :disabled="isSubmitting")
                | {{ $t('forms.noo') }}

        button.button-link.is-medium(v-load="isSubmitting") {{ $t('formCta') }}

  .u-mb-md
</template>

<script>
import { mapActions } from 'vuex';
import { load } from '~/directives';
import TextInput from '~/components/inputs/TextInput';
import SelectInput from '~/components/inputs/SelectInput';
import { ValidationObserver } from 'vee-validate/dist/vee-validate.minimal';
import countries from '~/assets/data/countries';
import { CreateRequest } from '~/graphql/Franchise.gql';

const createForm = () => ({
  firstName: '',
  lastName: '',
  nationality: '',
  country: '',
  birthDate: '',
  address: '',
  taxId: '',
  email: '',
  phone: '',
  fax: '',
  city: '',
  state: '',
  employer: '',
  experience: '',
  isOnlyIncome: true,
  investmentTime: '',
  involvement: '',
  location: '',
  haveInvestors: true
});

export default {
  scrollToTop: true,
  head() {
    const $t = this.$t.bind(this);

    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  },
  components: {
    TextInput,
    ValidationObserver,
    SelectInput
  },
  directives: {
    load
  },
  data: () => ({
    countries,
    hasExperience: false,
    selfEmployed: true,
    isSubmitting: false,
    form: createForm()
  }),
  methods: {
    ...mapActions({
      success: 'alert/success',
      error: 'alert/error'
    }),
    async onSubmit() {
      try {
        this.isSubmitting = true;
        await this.$api.mutate({
          mutation: CreateRequest,
          variables: {
            input: {
              ...this.form,
              employer: this.form.employer ? this.form.employer : 'SELF',
              experience: this.form.experience || 'No experience',
              nationality: this.form.nationality.iso2,
              location: this.form.location.iso2,
              country: this.form.country.iso2
            }
          }
        });

        this.success(this.$t('success'));
        this.form = createForm();
        requestAnimationFrame(() => {
          this.$refs.form.reset();
        });
      } catch (err) {
        this.error(this.$t('error'));
        console.error(err);
      } finally {
        this.isSubmitting = false;
      }
    }
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Baianat Franchise",
    "pageDesc":"Become one of Baianat franchisors and start your business with a strategic partner that supports your rapid growth.",
    "mantra":"Let’s build a great |business, together.",
    "formDesc":"The completion of this form is to receive information about franchise opportunities only and does not obligate you to purchase a franchise.",
    "formCta":"Let’s partner.",
    "personalInformation":"Your Personal Information",
    "businessInformation":"Business Information",
    "franchiseOperations":"Franchise operations",
    "success": "We will review your request and get back to you soon.",
    "error": "Failed to send the request, please try again later."
  },
  "ar": {
    "pageTitle":"حق الإمتياز من بيانات ",
    "pageDesc":"لدعم حقيقي يسير بأعمالك نحو النمو والازدهار، ومن أجل تبادل مثمر للخبرات، احصل على حق الامتياز من بيانات كخطوة نحو النجاح",
    "mantra":"معًا لنبني عملًا |ناجحًا.",
    "formDesc":"استكمال هذا النموذج هو من أجل الحصول على معلومات حول فرص حق الامتياز فقط ولا يلزمك بشراء حق الامتياز.",
    "formCta":"لنكن شركاء!",
    "personalInformation":"معلوماتك الشخصية",
    "businessInformation":"معلومات العمل التجاري",
    "franchiseOperations":"معلومات حول عملية حق الامتياز",
    "success": "سنقوم بمراجعة طلبك والرد عليك قريباً.",
    "error": "فشل ارسال الطلب، حاول لاحقاً من فضلك."
  }
}
</i18n>
